import { Component, OnInit, ViewChild, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { startWith, tap, filter, debounceTime, map, elementAt } from 'rxjs/operators';
import { of, Observable, fromEvent } from 'rxjs';
import { CalculationService } from '../../services/calculation.service'
import { ProgressSpinnerComponent } from '../progress-spinner/progress-spinner.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {saveAs} from 'file-saver';
import millify from 'millify';


export const DATA = [{"year":1990,"age":1,"startBalance":244856,"portfolioGain":6872,"socialIncome":7360,"annualIncome":6939,"annualExpense":3485,"endingBalance":24752},
{"year":1999,"age":8,"startBalance":541635,"portfolioGain":6162,"socialIncome":7360,"annualIncome":7425,"annualExpense":4776,"endingBalance":76309},
{"year":2011,"age":2,"startBalance":324450,"portfolioGain":8008,"socialIncome":7360,"annualIncome":7360,"annualExpense":8742,"endingBalance":22487},
{"year":1995,"age":3,"startBalance":565073,"portfolioGain":3940,"socialIncome":7360,"annualIncome":3696,"annualExpense":914,"endingBalance":74949},
{"year":2012,"age":4,"startBalance":713162,"portfolioGain":5280,"socialIncome":7360,"annualIncome":1614,"annualExpense":1715,"endingBalance":20668},
{"year":2010,"age":5,"startBalance":449978,"portfolioGain":5293,"socialIncome":7360,"annualIncome":9148,"annualExpense":8798,"endingBalance":96728},
{"year":1997,"age":6,"startBalance":60065,"portfolioGain":5289,"socialIncome":7360,"annualIncome":753,"annualExpense":775,"endingBalance":55231},
{"year":1992,"age":7,"startBalance":373809,"portfolioGain":9218,"socialIncome":7360,"annualIncome":6060,"annualExpense":1625,"endingBalance":10330},
{"year":1999,"age":8,"startBalance":541635,"portfolioGain":6162,"socialIncome":7360,"annualIncome":7425,"annualExpense":4776,"endingBalance":76309},
{"year":1992,"age":9,"startBalance":440164,"portfolioGain":8011,"socialIncome":7360,"annualIncome":6953,"annualExpense":2098,"endingBalance":13279},
{"year":1998,"age":10,"startBalance":655644,"portfolioGain":1663,"socialIncome":7360,"annualIncome":6611,"annualExpense":4531,"endingBalance":87023},
{"year":2002,"age":11,"startBalance":982411,"portfolioGain":9994,"socialIncome":7360,"annualIncome":7933,"annualExpense":2355,"endingBalance":5905},
{"year":1996,"age":12,"startBalance":239798,"portfolioGain":3007,"socialIncome":7360,"annualIncome":902,"annualExpense":1224,"endingBalance":42511},
{"year":1988,"age":13,"startBalance":344353,"portfolioGain":4398,"socialIncome":7360,"annualIncome":3378,"annualExpense":2429,"endingBalance":86794},
{"year":2006,"age":14,"startBalance":809966,"portfolioGain":357,"socialIncome":7360,"annualIncome":2358,"annualExpense":6672,"endingBalance":49738},
{"year":2005,"age":15,"startBalance":409387,"portfolioGain":2212,"socialIncome":7360,"annualIncome":3821,"annualExpense":8027,"endingBalance":64929},
{"year":1997,"age":16,"startBalance":498715,"portfolioGain":3449,"socialIncome":7360,"annualIncome":7067,"annualExpense":570,"endingBalance":16618},
{"year":2002,"age":17,"startBalance":731136,"portfolioGain":3521,"socialIncome":7360,"annualIncome":1457,"annualExpense":6673,"endingBalance":72675},
{"year":2006,"age":18,"startBalance":493374,"portfolioGain":4944,"socialIncome":7360,"annualIncome":430,"annualExpense":4825,"endingBalance":18886},
{"year":1988,"age":19,"startBalance":972047,"portfolioGain":4376,"socialIncome":7360,"annualIncome":8663,"annualExpense":6685,"endingBalance":73259},
{"year":2004,"age":20,"startBalance":789419,"portfolioGain":8163,"socialIncome":7360,"annualIncome":2102,"annualExpense":7413,"endingBalance":71775},
{"year":1988,"age":21,"startBalance":772969,"portfolioGain":2974,"socialIncome":7360,"annualIncome":6350,"annualExpense":7690,"endingBalance":11848},
{"year":1988,"age":22,"startBalance":635438,"portfolioGain":6596,"socialIncome":7360,"annualIncome":1844,"annualExpense":8121,"endingBalance":17495},
{"year":2009,"age":23,"startBalance":201426,"portfolioGain":314,"socialIncome":7360,"annualIncome":4989,"annualExpense":1255,"endingBalance":11056},
{"year":2009,"age":24,"startBalance":624914,"portfolioGain":2044,"socialIncome":7360,"annualIncome":7627,"annualExpense":8713,"endingBalance":62013},
{"year":1994,"age":25,"startBalance":557497,"portfolioGain":9869,"socialIncome":7360,"annualIncome":5336,"annualExpense":1868,"endingBalance":59979},
{"year":2008,"age":26,"startBalance":607475,"portfolioGain":9583,"socialIncome":7360,"annualIncome":2193,"annualExpense":4652,"endingBalance":83584},
{"year":2002,"age":27,"startBalance":6588,"portfolioGain":2094,"socialIncome":7360,"annualIncome":1797,"annualExpense":7300,"endingBalance":73485},
{"year":2003,"age":28,"startBalance":647127,"portfolioGain":2042,"socialIncome":7360,"annualIncome":6075,"annualExpense":3973,"endingBalance":85892},
{"year":1959,"age":29,"startBalance":205885,"portfolioGain":6799,"socialIncome":7360,"annualIncome":2180,"annualExpense":6873,"endingBalance":10173},
{"year":2013,"age":30,"startBalance":626647,"portfolioGain":9505,"socialIncome":7360,"annualIncome":8571,"annualExpense":392,"endingBalance":35288},
{"year":2009,"age":31,"startBalance":259350,"portfolioGain":1458,"socialIncome":7360,"annualIncome":6408,"annualExpense":7853,"endingBalance":50023},
{"year":1994,"age":32,"startBalance":96292,"portfolioGain":1860,"socialIncome":7360,"annualIncome":1909,"annualExpense":2221,"endingBalance":3213},
{"year":2004,"age":33,"startBalance":812101,"portfolioGain":2481,"socialIncome":7360,"annualIncome":292,"annualExpense":3605,"endingBalance":80001},
{"year":1962,"age":34,"startBalance":204003,"portfolioGain":9583,"socialIncome":7360,"annualIncome":1372,"annualExpense":7678,"endingBalance":38230},
{"year":2012,"age":35,"startBalance":72784,"portfolioGain":7986,"socialIncome":7360,"annualIncome":123,"annualExpense":2643,"endingBalance":4948},
{"year":1998,"age":36,"startBalance":25369,"portfolioGain":3164,"socialIncome":7360,"annualIncome":6683,"annualExpense":1665,"endingBalance":94766},
{"year":1995,"age":37,"startBalance":173805,"portfolioGain":4167,"socialIncome":7360,"annualIncome":2791,"annualExpense":6611,"endingBalance":95105},
{"year":2006,"age":38,"startBalance":140046,"portfolioGain":1283,"socialIncome":7360,"annualIncome":4971,"annualExpense":5773,"endingBalance":82999},
{"year":1990,"age":39,"startBalance":719845,"portfolioGain":4680,"socialIncome":7360,"annualIncome":7649,"annualExpense":6418,"endingBalance":72776},
{"year":1992,"age":40,"startBalance":445265,"portfolioGain":371,"socialIncome":7360,"annualIncome":1207,"annualExpense":7657,"endingBalance":76041},
{"year":1995,"age":41,"startBalance":93090,"portfolioGain":9494,"socialIncome":7360,"annualIncome":8491,"annualExpense":3648,"endingBalance":2184},
{"year":2003,"age":42,"startBalance":504927,"portfolioGain":14,"socialIncome":7360,"annualIncome":3794,"annualExpense":3297,"endingBalance":13899},
{"year":2010,"age":43,"startBalance":374976,"portfolioGain":5904,"socialIncome":7360,"annualIncome":106,"annualExpense":4689,"endingBalance":28347},
{"year":1995,"age":44,"startBalance":594231,"portfolioGain":4455,"socialIncome":7360,"annualIncome":5676,"annualExpense":8896,"endingBalance":22904},
{"year":2006,"age":45,"startBalance":389497,"portfolioGain":6663,"socialIncome":7360,"annualIncome":4079,"annualExpense":4968,"endingBalance":93050},
{"year":2006,"age":46,"startBalance":215757,"portfolioGain":3422,"socialIncome":7360,"annualIncome":7037,"annualExpense":8726,"endingBalance":32841},
{"year":2001,"age":47,"startBalance":834064,"portfolioGain":995,"socialIncome":7360,"annualIncome":7885,"annualExpense":1992,"endingBalance":20719},
{"year":1987,"age":48,"startBalance":81003,"portfolioGain":2457,"socialIncome":7360,"annualIncome":6024,"annualExpense":840,"endingBalance":92746},
{"year":2001,"age":49,"startBalance":783421,"portfolioGain":1487,"socialIncome":7360,"annualIncome":9757,"annualExpense":217,"endingBalance":1709},
{"year":2012,"age":50,"startBalance":240249,"portfolioGain":9515,"socialIncome":7360,"annualIncome":7842,"annualExpense":6823,"endingBalance":86383}];
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexStroke,
  ApexMarkers,
  ApexYAxis,
  ApexGrid,
  ApexTitleSubtitle,
  ApexLegend,
  ApexOptions,
  ApexTooltip,
  ApexResponsive,
} from "ng-apexcharts";
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';


export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  markers: ApexMarkers;
  tooltip: ApexTooltip; // ApexTooltip;
  yaxis: ApexYAxis;
  grid: ApexGrid;
  legend: ApexLegend;
  title: ApexTitleSubtitle;
  colors: any[];
  responsive: ApexResponsive[];
};
export interface StepType {
  label: string;
  fields: FormlyFieldConfig[];
}
@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class CalculatorComponent implements OnInit {
  @ViewChild("stepper") stepper: MatStepper;
  dataSource: MatTableDataSource<any> = new MatTableDataSource(DATA);
  displayedColumns: string[] = ['year', 'age', 'startBalance', 'portfolioGain','socialIncome', 'annualIncome', 'annualExpense', 'endingBalance'];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  yearOptions: string[] = [];
  startYearOptions: string[] = [];
  constructor(private formBuilder: FormBuilder, private currencyPipe: CurrencyPipe, private percentPipe: PercentPipe, private calculationService: CalculationService, private snackBar: MatSnackBar,private dialog: MatDialog) {
    // this.stepper.steps.forEach( step => {
    //   step.completed = false;
    // })
    this.yearOptions = this.generateYearOptions();
    this.startYearOptions = this.generateStartYearOptions();
    this.chartOptions = {
      series: [
        {
          name: 'Annual Incomes',
          // data: [],
          data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10]
        },
        {
          name: 'Annual Expenses',
          // data: [],
          data: [35, 41, 62, 42, 13, 18, 29, 37, 36, 51, 32, 35]
        },
        {
          name: 'Portfolio Gains',
          // data: [],
          data: [87, 57, 74, 99, 75, 38, 62, 47, 82, 56, 45, 47]
        },
        {
          name: 'Ending Balance',
          // data: [],
          data: [100, 23, 72, 33, 21, 14, 6, 2, 10, 21, 12, 4]
        }
      ],
      chart: {
        height: 600,
        type: 'line',
        fontFamily: '"Open Sans Regular", sans-serif',
        zoom:{
          enabled:false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 5,
        curve: 'smooth',
        // dashArray: [0, 8, 5],
      },
      title: {
        text: 'Financial Projection',
        align: 'left',
        style: {
          fontSize: '24px',
          fontFamily: '"Open Sans Regular", sans-serif',
          fontWeight: 600
        },
      },
      colors: [
        '#388e3c', // Mat Green 700
        '#d32f2f', // Mat Red 700
        '#fecd5c', // Chapwood Yellow
        '#244768', // Chapwood Blue Primary
      ],
      legend: {
        fontSize: '14px',
        tooltipHoverFormatter: function(val, opts) {
          return (
            val +
            " - <strong>" +
            currencyPipe.transform(opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex], 'USD', 'symbol-narrow', '1.0-0') +
            "</strong>"
          );
        },
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 6
        }
      },
      xaxis: {
        labels: {
          style: {
            fontSize: '14px',
          },
          trim: false,
        },
        categories: [
          "2020",
          "2021",
          "2022",
          "2023",
          "2024",
          "2025",
          "2026",
          "2027",
          "2028",
          "2029",
          "2030",
          "2031"
        ],
      },
      yaxis: {
        labels: {
          style: {
            fontSize: '14px',
          },
          formatter: function (value) {
            if (value && value !== NaN){
              return currencyPipe.transform(value.toString(), 'USD', 'symbol-narrow', '1.0-0');
            }
          }
        },
      },
      tooltip: {
        style: {
          fontSize: '14px',
        },
        y: [
          {
            title: {
              formatter: function(val) {
                return val;
              }
            }
          },
          {
            title: {
              formatter: function(val) {
                return val;
              }
            }
          },
          {
            title: {
              formatter: function(val) {
                return val;
              }
            }
          },
          {
            title: {
              formatter: function(val) {
                return  val;
              }
            }
          }
        ]
      },
      grid: {
        borderColor: "#f1f1f1"
      },
      // responsive: [{
      //   breakpoint: 768,
      //   options: {
      //     title: {
      //       text: 'Financial Projection',
      //       align: 'left',
      //       style: {
      //         fontSize: '16px',
      //       },
      //     },
      //     chart: {
      //       toolbar: {
      //         show: false
      //       }
      //     }
      //   }
      // }]
    };
  }

  mobile: boolean = false;
  checkScreenSize: any;
  ngOnInit() {
    this.dataSource.paginator = this.paginator;
  }

  activedStep = 0;

  model: any = {};
  steps: StepType[] = [
    {
      label: 'Questionnaire',
      fields: [
        {
          key: 'Name',
          type: 'input',
          defaultValue:'',
          templateOptions: {
            label: 'Enter Name',
            required: true
          },
        },
        {
          key: 'startYear',
          type: 'autocomplete',
          defaultValue: new Date().getFullYear().toString(),
          templateOptions: {
            label: 'Start Year',
            required: true,
            filter: (term: string) => of(term ? this.startYearOptions.filter(year => year.toLowerCase().indexOf(term.toLowerCase()) === 0) : this.startYearOptions.slice()),
          },
        },
        {
          key: 'currentAge',
          type: 'input',
          templateOptions: {
            label: 'Current Age',
            required: true,
            blur: (formlyFieldConfig: FormlyFieldConfig) => {
              if (this.model.currentAge){
                let value: string = (this.model.currentAge as string).replace(/[^0-9.-]+/g,'');
                formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'currentAge').formControl.patchValue(value);
              }
            },
          },
          modelOptions: {
            updateOn: 'blur'
          }
        },
        {
          key: 'portfolioValue',
          type: 'input',
          templateOptions: {
            label: 'Portfolio Value',
            required: true,
            blur: (formlyFieldConfig: FormlyFieldConfig) => {
              if (this.model.portfolioValue){
                let value: string = (this.model.portfolioValue as string).replace(/[^0-9.-]+/g,'');
                formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'portfolioValue').formControl.patchValue(this.currencyPipe.transform(value, 'USD', 'symbol-narrow', '1.0-0'));
              }
            }
          },
          modelOptions: {
            updateOn: 'blur'
          }
        },
        {
          key: 'taxBracket',
          type: 'input',
          templateOptions: {
            label: 'Tax Bracket',
            required: true,
            blur: (formlyFieldConfig: FormlyFieldConfig) => {
              if(this.model.taxBracket) {
                let value: string = (this.model.taxBracket as string).replace(/[^0-9.-]+/g,'');
                value = (parseFloat(value)/100).toString();
                if (value && value !== 'NaN'){
                  formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'taxBracket').formControl.patchValue(this.percentPipe.transform(value, '1.0-2'));
                } else {
                  formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'taxBracket').formControl.patchValue('');
                }
              }
            }
          },
          modelOptions: {
            updateOn: 'blur'
          }
        },
        {
          key: 'costOfLivingIncrease',
          type: 'input',
          templateOptions: {
            label: 'Cost Of Living Increase',
            required: true,
            blur: (formlyFieldConfig: FormlyFieldConfig) => {
              if(this.model.costOfLivingIncrease) {
                let value: string = (this.model.costOfLivingIncrease as string).replace(/[^0-9.-]+/g,'');
                value = (parseFloat(value)/100).toString();
                if (value && value !== 'NaN'){
                  formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'costOfLivingIncrease').formControl.patchValue(this.percentPipe.transform(value, '1.0-2'));
                } else {
                  formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'costOfLivingIncrease').formControl.patchValue('');
                }
              }
            }
          },
          modelOptions: {
            updateOn: 'blur'
          }
        },
      ],
    },
    {
      label: 'Income',
      fields: [
        {
          key: 'incomeType',
          type: 'radio',
          defaultValue: 'Fixed',
          // className: 'flex-1',
          templateOptions: {
            label: 'Income Type',
            options: [
              {value: 'Fixed', label: 'Fixed'},
              {value: 'Variable', label: 'Variable'}
            ],
          },

        },
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              key: 'portfolioGrowth',
              type: 'input',
              className: 'flex-2',
              templateOptions: {
                label: 'Expected Portfolio Growth Rate',
                required: true,
                blur: (formlyFieldConfig: FormlyFieldConfig) => {
                  if(this.model.portfolioGrowth) {
                    let value: string = (this.model.portfolioGrowth as string).replace(/[^0-9.-]+/g,'');
                    value = (parseFloat(value)/100).toString();
                    if (value && value !== 'NaN'){
                      formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'portfolioGrowth').formControl.patchValue(this.percentPipe.transform(value, '1.0-2'));
                    } else {
                      formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'portfolioGrowth').formControl.patchValue('');
                    }
                  }
                }
              },
              modelOptions: {
                updateOn: 'blur'
              }
            },
          ],
          // hideExpression: () => {
          //   let incomeType = this.steps[1].fields[0].formControl.value;
          //   if (incomeType == 'Fixed'){
          //     return false;
          //   }
          //   return true;
          // }
        },
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              key: 'fixedAnnualIncome',
              type: 'input',
              className: 'flex-3',
              templateOptions: {
                label: 'Expected Annual Income',
                required: true,
                blur: (formlyFieldConfig: FormlyFieldConfig) => {
                  if (this.model.fixedAnnualIncome){
                    let value: string = (this.model.fixedAnnualIncome as string).replace(/[^0-9.-]+/g,'');
                    formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'fixedAnnualIncome').formControl.patchValue(this.currencyPipe.transform(value, 'USD', 'symbol-narrow', '1.0-0'));
                  }
                }
              },
              modelOptions: {
                updateOn: 'blur'
              }
            },
            {
              key: 'fixedAnnualIncomePeriod',
              type: 'autocomplete',
              className: 'flex-1',
              templateOptions: {
                label: 'Number of Years',
                required: true,
                filter: (term: string) => of(term ? this.yearOptions.filter(year => year.toLowerCase().indexOf(term.toLowerCase()) === 0) : this.yearOptions.slice())
              },
            },
          ],
          hideExpression: () => {
            let incomeType = this.steps[1].fields[0].formControl.value;
            if (incomeType == 'Fixed'){
              return false;
            }
            return true;
          }
        },
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              key: 'fixedAnnualIncomeGrowth',
              type: 'input',
              className: 'flex-2',
              templateOptions: {
                label: 'Annual Income Growth Rate',
                required: true,
                blur: (formlyFieldConfig: FormlyFieldConfig) => {
                  if(this.model.fixedAnnualIncomeGrowth) {
                    let value: string = (this.model.fixedAnnualIncomeGrowth as string).replace(/[^0-9.-]+/g,'');
                    value = (parseFloat(value)/100).toString();
                    if (value && value !== 'NaN'){
                      formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'fixedAnnualIncomeGrowth').formControl.patchValue(this.percentPipe.transform(value, '1.0-2'));
                    } else {
                      formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'fixedAnnualIncomeGrowth').formControl.patchValue('');
                    }
                  }
                }
              },
              modelOptions: {
                updateOn: 'blur'
              }
            },
          ],
          hideExpression: () => {
            let incomeType = this.steps[1].fields[0].formControl.value;
            if (incomeType == 'Fixed'){
              return false;
            }
            return true;
          }
        },

                //social security input
                {
                  fieldGroupClassName: 'display-flex',
                  fieldGroup: [
                    {
                      key: 'socialSecurityIncome',
                      type: 'input',
                      className: 'flex-3',
                      templateOptions: {
                        label: 'Social Security Income',
                        blur: (formlyFieldConfig: FormlyFieldConfig) => {
                          if (this.model.socialSecurityIncome){
                            let value: string = (this.model.socialSecurityIncome as string).replace(/[^0-9.-]+/g,'');
                            formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'socialSecurityIncome').formControl.patchValue(this.currencyPipe.transform(value, 'USD', 'symbol-narrow', '1.0-0'));
                          }
                        }
                      },
                      modelOptions: {
                        updateOn: 'blur'
                      }
                    },
                    {
                      key: 'socialSecurityIncomeGrowthRate',
                      type: 'input',
                      className: 'flex-3',
                      templateOptions: {
                        label: 'Social Security Income Growth Rate',
                        blur: (formlyFieldConfig: FormlyFieldConfig) => {
                          if(this.model.socialSecurityIncomeGrowthRate) {
                            let value: string = (this.model.socialSecurityIncomeGrowthRate as string).replace(/[^0-9.-]+/g,'');
                            value = (parseFloat(value)/100).toString();
                            if (value && value !== 'NaN'){
                              formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'socialSecurityIncomeGrowthRate').formControl.patchValue(this.percentPipe.transform(value, '1.0-2'));
                            } else {
                              formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'socialSecurityIncomeGrowthRate').formControl.patchValue('');
                            }
                          }
                        }
                      },
                      modelOptions: {
                        updateOn: 'blur'
                      }
                    },
                    {
                      key: 'socialSecurityStartYear',
                      type: 'autocomplete',
                      className:'flex-2',
                      templateOptions: {
                        label: 'Starting Year',
                        // required: true,
                        filter: (term: string) => of(term ? this.startYearOptions.filter(year => year.toLowerCase().indexOf(term.toLowerCase()) === 0) : this.startYearOptions.slice()),
                      },
                    },
                  ]
                },



        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              key: 'variableIncomePeriod',
              type: 'autocomplete',
              className: 'flex-2',
              templateOptions: {
                label: 'Years of Variable Income',
                required: true,
                filter: (term: string) => of(term ? this.yearOptions.filter(year => year.toLowerCase().indexOf(term.toLowerCase()) === 0) : this.yearOptions.slice()),
                change: (formlyFieldConfig: FormlyFieldConfig) => {
                  if (this.model.variableIncomePeriod){
                    let value: string = (this.model.variableIncomePeriod as string).replace(/[^0-9.-]+/g,'');
                    formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'variableIncomePeriod').formControl.patchValue(value);
                  }
                },
              },
              modelOptions: {
                updateOn: 'change'
              },
              hooks: {
                onInit: (field) => {
                  return field.formControl.valueChanges.pipe(
                    startWith(field.formControl.value),
                    filter(v => v > 0),
                    tap(value => {
                      this.model.variableAnnualIncomes.length = value;
                      this.model = {
                        ...this.model,
                        variableAnnualIncomesCount: value,
                      };
                    }),
                  );
                }
              },
            },
          ],
          hideExpression: () => {
            let incomeType = this.steps[1].fields[0].formControl.value;
            if (incomeType == 'Variable'){
              return false;
            }
            return true;
          }
        },
        {
          key: 'variableAnnualIncomes',
          type: 'repeat',
          fieldArray: {
            type: 'input',
            key: 'variableIncome',
            modelOptions: {
              updateOn: 'blur'
            },
            templateOptions: {
              label: 'Income',
              required: true,
              blur: (formlyFieldConfig: FormlyFieldConfig) => {
                if (this.model.variableAnnualIncomes){
                  for (let i = 0; i < this.model.variableAnnualIncomes.length; i++) {
                    if(this.model.variableAnnualIncomes[i]){
                      let value: string = (this.model.variableAnnualIncomes[i] as string).replace(/[^0-9.-]+/g,'');
                      formlyFieldConfig.parent.fieldGroup[i].formControl.patchValue(this.currencyPipe.transform(value, 'USD', 'symbol-narrow', '1.0-0'));
                    }
                  }
                }
              }
            },
          },
          hideExpression: () => {
            // console.log(this.steps[1].fields);
            let incomeType = this.steps[1].fields[0].formControl.value;
            if (incomeType == 'Variable'){
              return false;
            }
            return true;
          }
        },
      ],
    },
    {
      label: 'Expense',
      fields: [
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              key: 'monthlyMortagePayment',
              type: 'input',
              className: 'flex-3',
              templateOptions: {
                label: 'Monthly Mortgage Payment',
                blur: (formlyFieldConfig: FormlyFieldConfig) => {
                  if (this.model.monthlyMortagePayment){
                    let value: string = (this.model.monthlyMortagePayment as string).replace(/[^0-9.-]+/g,'');
                    formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'monthlyMortagePayment').formControl.patchValue(this.currencyPipe.transform(value, 'USD', 'symbol-narrow', '1.0-0'));
                  }
                }
              },
              modelOptions: {
                updateOn: 'blur'
              }
            },
            {
              key: 'monthlyMortagePaymentPeriod',
              type: 'autocomplete',
              className: 'flex-1',
              templateOptions: {
                label: 'Number of Years',
                filter: (term: string) => of(term ? this.yearOptions.filter(year => year.toLowerCase().indexOf(term.toLowerCase()) === 0) : this.yearOptions.slice())
              },
            },
          ]
        },
        // {
        //   fieldGroupClassName: 'display-flex',
        //   fieldGroup: [
        //     {
        //       key: 'monthlyCarPayment',
        //       type: 'input',
        //       className: 'flex-3',
        //       templateOptions: {
        //         label: 'Monthly Car Payment',
        //         blur: (formlyFieldConfig: FormlyFieldConfig) => {
        //           if (this.model.monthlyCarPayment){
        //             let value: string = (this.model.monthlyCarPayment as string).replace(/[^0-9.-]+/g,'');
        //             formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'monthlyCarPayment').formControl.patchValue(this.currencyPipe.transform(value, 'USD', 'symbol-narrow', '1.0-0'));
        //           }
        //         }
        //       },
        //       modelOptions: {
        //         updateOn: 'blur'
        //       }
        //     },
        //     {
        //       key: 'monthlyCarPaymentPeriod',
        //       type: 'autocomplete',
        //       className: 'flex-1',
        //       templateOptions: {
        //         label: 'Number of Years',
        //         filter: (term: string) => of(term ? this.yearOptions.filter(year => year.toLowerCase().indexOf(term.toLowerCase()) === 0) : this.yearOptions.slice())
        //       },
        //     },
        //   ]
        // },
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              key: 'monthlyFamilyPayment',
              type: 'input',
              className: 'flex-3',
              templateOptions: {
                label: 'Monthly Money to Friends and Family',
                blur: (formlyFieldConfig: FormlyFieldConfig) => {
                  if (this.model.monthlyFamilyPayment){
                    let value: string = (this.model.monthlyFamilyPayment as string).replace(/[^0-9.-]+/g,'');
                    formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'monthlyFamilyPayment').formControl.patchValue(this.currencyPipe.transform(value, 'USD', 'symbol-narrow', '1.0-0'));
                  }
                }
              },
              modelOptions: {
                updateOn: 'blur'
              }
            },
            {
              key: 'monthlyFamilyPaymentPeriod',
              type: 'autocomplete',
              className: 'flex-1',
              templateOptions: {
                label: 'Number of Years',
                filter: (term: string) => of(term ? this.yearOptions.filter(year => year.toLowerCase().indexOf(term.toLowerCase()) === 0) : this.yearOptions.slice())
              },
            },
          ]
        },
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              key: 'monthlyLivingExpenses',
              type: 'input',
              className: 'flex-3',
              templateOptions: {
                label: 'Monthly Living Expenses',
                blur: (formlyFieldConfig: FormlyFieldConfig) => {
                  if (this.model.monthlyLivingExpenses){
                    let value: string = (this.model.monthlyLivingExpenses as string).replace(/[^0-9.-]+/g,'');
                    formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'monthlyLivingExpenses').formControl.patchValue(this.currencyPipe.transform(value, 'USD', 'symbol-narrow', '1.0-0'));
                  }
                }
              },
              modelOptions: {
                updateOn: 'blur'
              }
            },
            {
              key: 'monthlyLivingExpensesPeriod',
              type: 'autocomplete',
              className: 'flex-1',
              templateOptions: {
                label: 'Number of Years',
                filter: (term: string) => of(term ? this.yearOptions.filter(year => year.toLowerCase().indexOf(term.toLowerCase()) === 0) : this.yearOptions.slice())
              },
            },
          ]
        },
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              key: 'rateOfExpenseDecline',
              type: 'input',
              className: 'flex-3',
              templateOptions: {
                label: 'Rate Of Expense Decline Per Year',
                blur: (formlyFieldConfig: FormlyFieldConfig) => {
                  if(this.model.rateOfExpenseDecline) {
                    let value: string = (this.model.rateOfExpenseDecline as string).replace(/[^0-9.-]+/g,'');
                    value = (parseFloat(value)/100).toString();
                    if (value && value !== 'NaN'){
                      formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'rateOfExpenseDecline').formControl.patchValue(this.percentPipe.transform(value, '1.0-2'));
                    } else {
                      formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'rateOfExpenseDecline').formControl.patchValue('');
                    }
                  }
                }
              },
              modelOptions: {
                updateOn: 'blur'
              }
            },
            {
              key: 'expenseDeclineStartYear',
              type: 'autocomplete',
              className:'flex-1',
              templateOptions: {
                label: 'Starting Year',
                // required: true,
                filter: (term: string) => of(term ? this.startYearOptions.filter(year => year.toLowerCase().indexOf(term.toLowerCase()) === 0) : this.startYearOptions.slice()),
              },
            },
          ]
        },
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              key: 'monthlyOtherExpenses',
              type: 'input',
              className: 'flex-3',
              templateOptions: {
                label: 'Annual Other Expenses',
                blur: (formlyFieldConfig: FormlyFieldConfig) => {
                  if (this.model.monthlyOtherExpenses){
                    let value: string = (this.model.monthlyOtherExpenses as string).replace(/[^0-9.-]+/g,'');
                    formlyFieldConfig.parent.fieldGroup.find(k => k.key === 'monthlyOtherExpenses').formControl.patchValue(this.currencyPipe.transform(value, 'USD', 'symbol-narrow', '1.0-0'));
                  }
                }
              },
              modelOptions: {
                updateOn: 'blur'
              }
            },
            {
              key: 'monthlyOtherExpensesPeriod',
              type: 'autocomplete',
              className: 'flex-1',
              templateOptions: {
                label: 'Number of Years',
                filter: (term: string) => of(term ? this.yearOptions.filter(year => year.toLowerCase().indexOf(term.toLowerCase()) === 0) : this.yearOptions.slice())
              },
            },
          ]
        },
      ],
    },
  ];

  form = new FormArray(this.steps.map(() => new FormGroup({})));
  options = this.steps.map(() => <FormlyFormOptions> {});
  responseObject: any;
  tableData: any;
  expenseDuration: number;

  isSubmitted: boolean = false;
  isBroke: boolean = false;
  payload:any;

  prevStep(step) {
    this.activedStep = step - 1;
  }

  nextStep(step) {
    this.activedStep = step + 1;
  }
  convertToNumber(value: string){
    //Only accepting ints for now
    return parseFloat(value.replace(/[^0-9.-]+/g,''));
  }
  generatePeriodOptions(){
    let options = [];
    for (let i = 1; i <= 50; i++){
      options.push({
        value: i.toString(),
        label: i.toString()
      });
    }
    return options;
  }

  generateYearOptions(): string[]{
    let options = [];
    for (let i = 1; i <= 50; i++){
      options.push(i.toString());
    }
    return options;
  }

  generateStartYearOptions(): string[]{
    let options = [];
    let currentYear = new Date().getFullYear();
    for (let i = 0; i <= 30; i++){
      options.push((currentYear + i).toString());
    }
    return options;
  }
  submit() {
    this.isBroke=false;
    const distressPayload = {
      cost_of_living_increase: this.model.costOfLivingIncrease? this.convertToNumber(this.model.costOfLivingIncrease): 0,
      current_age: this.model.currentAge? this.convertToNumber(this.model.currentAge): 0,
      fixed_annual_income: this.model.fixedAnnualIncome? this.convertToNumber(this.model.fixedAnnualIncome): 0,
      fixed_annual_income_growth: this.model.fixedAnnualIncomeGrowth? this.convertToNumber(this.model.fixedAnnualIncomeGrowth): 0,
      fixed_annual_income_period: this.model.fixedAnnualIncomePeriod? this.convertToNumber(this.model.fixedAnnualIncomePeriod): 0,
      monthly_car_payment: this.model.monthlyCarPayment? this.convertToNumber(this.model.monthlyCarPayment): 0,
      monthly_car_payment_period: this.model.monthlyCarPaymentPeriod? this.convertToNumber(this.model.monthlyCarPaymentPeriod): 0,
      monthly_family_payment: this.model.monthlyFamilyPayment? this.convertToNumber(this.model.monthlyFamilyPayment): 0,
      monthly_family_payment_period: this.model.monthlyFamilyPaymentPeriod? this.convertToNumber(this.model.monthlyFamilyPaymentPeriod): 0,
      monthly_living_expenses: this.model.monthlyLivingExpenses? this.convertToNumber(this.model.monthlyLivingExpenses): 0,
      monthly_living_expenses_period: this.model.monthlyLivingExpensesPeriod? this.convertToNumber(this.model.monthlyLivingExpensesPeriod): 0,
      rate_of_expense_decline:this.model.rateOfExpenseDecline? this.convertToNumber(this.model.rateOfExpenseDecline): 0,
      expense_decline_startyear:this.model.expenseDeclineStartYear?this.convertToNumber(this.model.expenseDeclineStartYear): 0,
      monthly_mortgage_payment: this.model.monthlyMortagePayment? this.convertToNumber(this.model.monthlyMortagePayment): 0,
      monthly_mortgage_payment_period: this.model.monthlyMortagePaymentPeriod? this.convertToNumber(this.model.monthlyMortagePaymentPeriod): 0,
      monthly_other_expenses: this.model.monthlyOtherExpenses? this.convertToNumber(this.model.monthlyOtherExpenses) / 12.0: 0, // Added to convert to annual expense
      monthly_other_expenses_period: this.model.monthlyOtherExpensesPeriod? this.convertToNumber(this.model.monthlyOtherExpensesPeriod): 0,
      portfolio_growth: this.model.portfolioGrowth? this.convertToNumber(this.model.portfolioGrowth): 0,
      portfolio_value: this.model.portfolioValue? this.convertToNumber(this.model.portfolioValue): 0,
      start_year: this.model.startYear? this.convertToNumber(this.model.startYear): 0,
      tax_bracket: this.model.taxBracket? this.convertToNumber(this.model.taxBracket): 0,
      variable_annual_incomes: this.model.variableAnnualIncomes? this.model.variableAnnualIncomes.map(income => this.convertToNumber(income)): [],

      social_security_income:this.model.socialSecurityIncome?this.convertToNumber(this.model.socialSecurityIncome):0,
      social_security_income_growth_rate:this.model.socialSecurityIncomeGrowthRate?this.convertToNumber(this.model.socialSecurityIncomeGrowthRate):0,
      social_security_startyear: this.model.socialSecurityStartYear? this.convertToNumber(this.model.socialSecurityStartYear): 0,

    };
    this.payload=distressPayload;
    // this.expenseDuration = Math.max(distressPayload.monthly_car_payment_period, distressPayload.monthly_family_payment_period, distressPayload.monthly_living_expenses_period,
    //   distressPayload.monthly_mortgage_payment_period, distressPayload.monthly_other_expenses_period);
    this.expenseDuration = Math.max(distressPayload.monthly_family_payment_period, distressPayload.monthly_living_expenses_period,
      distressPayload.monthly_mortgage_payment_period, distressPayload.monthly_other_expenses_period);

    this.calculationService.addDistress(distressPayload).subscribe( (response: any) => {
      this.isSubmitted = true;

      this.snackBar.open('Calculation Successful', 'Close', {
        panelClass: 'success-bg',
        duration: 2500
      });
      this.responseObject = response.createdDistress;
      if (this.responseObject.years_till_broke <= this.expenseDuration){
        this.isBroke = true
      }
      this.chartOptions.xaxis.categories.length = 0;
      let i = -1;
      this.tableData = [];
      for (i = 0; i < this.responseObject.years_till_broke -1; i++){
        this.tableData.push({
          year: distressPayload.start_year + i,
          age:  distressPayload.current_age + i,
          startBalance: this.responseObject.start_balances[i]? this.responseObject.start_balances[i] : NaN,
          portfolioGain: this.responseObject.portfolio_gains[i]? this.responseObject.portfolio_gains[i] : NaN,
          socialIncome:this.responseObject.social_security_incomes[i]? this.responseObject.social_security_incomes[i] : NaN,
          annualIncome: this.responseObject.cumulative_annual_incomes[i]? this.responseObject.cumulative_annual_incomes[i] : NaN,
          annualExpense: this.responseObject.cumulative_annual_expenses[i]? this.responseObject.cumulative_annual_expenses[i] : NaN,
          endingBalance: this.responseObject.ending_balances[i]? this.responseObject.ending_balances[i] : NaN,
        });
        this.chartOptions.xaxis.categories.push((distressPayload.start_year + i).toString());
      }
      // this.chartOptions.series.length = 0;
      this.chartOptions.series = [
        {
          name: "Annual Incomes",
          data: (this.tableData as Array<any>).map(interval => interval.annualIncome)

        },
        {
          name: "Annual Expenses",
          data: (this.tableData as Array<any>).map(interval => interval.annualExpense)
        },
        {
          name: "Portfolio Gains",
          data: (this.tableData as Array<any>).map(interval => interval.portfolioGain)
        },
        {
          name: "Ending Balance",
          data: (this.tableData as Array<any>).map(interval => interval.endingBalance)
        }
      ];
      let annual_exp=this.tableData.map(e=>{
        return e.annualExpense
      });
      let newtableData=this.tableData.map(e=>{
        return {...e,
                'startBalance':e.startBalance >999999 || (e.startBalance < -999999 && e.startBalance < 0)?'$' + millify(Math.trunc(Math.round(e.startBalance))):!Number.isNaN(e.startBalance) ? '$' + Math.trunc(Math.round(e.startBalance)).toLocaleString():'',
                'socialIncome':e.socialIncome >999999 || (e.socialIncome < -999999 && e.socialIncome < 0) ?'$' + millify(Math.trunc(Math.round(e.socialIncome))):!Number.isNaN(e.socialIncome) ?'$' + Math.trunc(Math.round(e.socialIncome)).toLocaleString():'',
                'annualIncome':e.annualIncome >999999 || (e.annualIncome < -999999 && e.annualIncome < 0) ?'$' + millify(Math.trunc(Math.round(e.annualIncome))):!Number.isNaN(e.annualIncome) ?'$' + Math.trunc(Math.round(e.annualIncome)).toLocaleString():'',
                'annualExpense':e.annualExpense >999999 || (e.annualExpense < 999999 && e.annualExpense < 0)?'$' + millify(Math.trunc(Math.round(e.annualExpense))):!Number.isNaN(e.annualExpense) ?'$' + Math.trunc(Math.round(e.annualExpense)).toLocaleString():'',
                'portfolioGain':e.portfolioGain > 999999 || (e.portfolioGain < -999999 && e.portfolioGain < 0) ?'$' + millify(Math.trunc(Math.round(e.portfolioGain))):!Number.isNaN(e.portfolioGain) ?'$' + Math.trunc(Math.round(e.portfolioGain)).toLocaleString():'',
                'endingBalance':e.endingBalance >999999 || (e.endingBalance < -999999 && e.endingBalance < 0) ?'$' + millify(Math.trunc(Math.round(e.endingBalance))):!Number.isNaN(e.endingBalance) ?'$' + Math.trunc(Math.round(e.endingBalance)).toLocaleString():''
              }
            });
      this.dataSource.data = newtableData;
      this.dataSource.paginator = this.paginator;
      // this.stepper.selected.completed = true;
      this.stepper.next(); // Moves to final step after
    }, error => {
      console.log(error);
      this.snackBar.open('Calculation Failed', 'Close', {
        panelClass: 'warn-bg',
        duration: 2500
      });
    });
  }

  getPDF()
  {
   let payload={
     'name':this.model.Name,
     'expense_duration':this.expenseDuration,
     'payload':this.payload
   }
   let dialogRef: MatDialogRef<ProgressSpinnerComponent> = this.dialog.open(ProgressSpinnerComponent, {
    panelClass: 'transparent',
    disableClose: true,
  })

   this.calculationService.downloadPDF(payload)
   .subscribe(res=>{
    dialogRef.close()
    if(res.byteLength>5)
    {
    var blob = new Blob([res],{type:'application/pdf'});
    const filename="Financial_Distress_Calculator.pdf"
    saveAs(blob,filename)
    }
  },(err)=>{
    dialogRef.close()
    if(err)
    {
      console.log(err)
      this.snackBar.open('Something went wrong!', 'Close', {
        panelClass: 'warn-bg',
        duration: 2500
      });
    }
  })
  }
}
